module.exports = __webpack_public_path__ + "img/wyyy.05bb7245.jpg";